import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">编辑精选的近期热门吃瓜内容，不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 5).map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-colors">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full">{item.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{item.description}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-calendar-line"></i>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}